import React from 'react';
import { Image } from 'react-bootstrap';
import Button from '../Shared/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/TerminalSuccessModal.css';
import success from '../../Assets/TruckVisits/Assets-Desktop/checked.svg';
import RespModal from '../Shared/RespModal';
function TerminalSuccessModal(props) {
    return(
         <RespModal hasOpen={props.hasOpen}  >
        <div className="TerminalSuccessmodalsize" >
            <Image src={success} height="60" width="60" /><br /><br /> 
            <div id="TerminalSuccessmodalcontainsuccess">
                 {props.children}
            </div>
            <Button
                id="TerminalSuccessresploginbutton"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >OK
        </Button><br /><br />
        </div>
     </RespModal> 
    );
}
export default TerminalSuccessModal; 